import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 *
 * @private
 * @param {any} a
 */
function isObject(a) {
  if (typeof a !== 'object' || a instanceof Array) {
    return false;
  } else {
    return true;
  }
}

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);
  }

  _createClass(Config, [{
    key: "filterOutNonSupportedKeys",
    value: function filterOutNonSupportedKeys(userProvidedConfig, validKeys) {
      var obj = Object.create({});

      if (isObject(userProvidedConfig)) {
        Object.keys(userProvidedConfig).forEach(function (key) {
          if (validKeys.indexOf(key) >= 0) {
            obj[key] = userProvidedConfig[key];
          } else {
            console.warn('Warning - unsupported key provided to configuration: ', key);
          }
        });
        return obj;
      } else {
        return Object.create({});
      }
    }
  }]);

  return Config;
}();

export default Config;